import React, { createContext, useEffect, useState } from 'react'
import MainLayout from '../../components/MainLayout';
import UserDataTable from './UserDataTable';
import { useSelector } from 'react-redux';
import { ApiServices } from '../../services/apiServices';
import { ApiConfig, driversListUrl } from '../../services/ApiConfigs';
import AddDrivers from './AddDrivers';
import { Button } from 'antd';


export const DriverContext = createContext({})

const Drivers = () => {

    const userDetail = useSelector((state) => state.UserData?.userData?.user || state.UserData?.userData?.franchise);
    const storeId = userDetail?.storeId;
    const isFranchise = useSelector((state) => state.UserData?.userData?.role === 'franchise' || state.UserData?.userData?.user?.role === 'franchise');

    const [userData, setUserData] = useState([])
    const [loader, setLoader] = useState(false);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [wareHouseData, setWarehouseData] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState({});

    const getUsers = async () => {
        try {
            setLoader(true)
            await ApiServices('get', driversListUrl(storeId)).then((res) => {
                let tmp = res?.data
                setLoader(false)
                console.log(tmp, "users response..")
                if (res.status == 200) {
                    setUserData(Array.isArray(tmp) ? tmp : [])
                } else {
                    setUserData([])
                }
            })
        } catch (error) {
            setLoader(false)
            console.log(error)
        }
    }

    useEffect(() => {
        getUsers()
        getWarehouse()
    }, [storeId])

    const getWarehouse = async () => {
        try {
            const res = await ApiServices('get', ApiConfig.WAREHOUSE);
            console.log(res, "get warehouser")
            setWarehouseData(res?.data || [])
        } catch (error) {
            console.log(error)
        }
    }

    // useEffect(() => {
    //     console.log(selectedDriver, "selectedDriver")
    // }, [selectedDriver])

    const deleteUser = async (id) => {
        try {
            setLoader(true)
            await ApiServices('delete', ApiConfig.DRIVER + '/' + id).then((res) => {
                console.log(res, "delete users response..")
                getUsers()
            })
        } catch (error) {
            setLoader(false)
            console.log(error)
        }
    }

    const data = {
        addModalOpen,
        setAddModalOpen,
        loader,
        deleteUser,
        userData,
        getUsers,
        viewModalOpen,
        setViewModalOpen,
        setSelectedDriver,
        driver: selectedDriver,
        wareHouseData,
        isFranchise,
        userDetail
    }

    return (
        <DriverContext.Provider value={data}>
            <MainLayout>
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    flexWrap: 'wrap',
                    gap: 12,
                    marginBottom: 20 
                }}>
                    <div>
                        <h2 style={{ 
                            margin: 0, 
                            fontSize: 22, 
                            fontWeight: 700, 
                            color: '#0f172a',
                            letterSpacing: '-0.02em' 
                        }}>
                            Drivers Management
                        </h2>
                        <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>
                            Manage delivery drivers, active availability, assignments, and contact channels
                        </div>
                    </div>
                    <Button 
                        type="primary" 
                        size="large"
                        style={{
                            borderRadius: 8,
                            fontWeight: 600,
                            boxShadow: '0 2px 6px rgba(37, 99, 235, 0.25)'
                        }}
                        onClick={() => {
                            setSelectedDriver({})
                            setAddModalOpen(true)
                        }}
                    >
                        + Add Driver
                    </Button>
                </div>
                <UserDataTable />
                <AddDrivers />
            </MainLayout>
        </DriverContext.Provider>
    )
}

export default Drivers